module.exports = __webpack_public_path__ + "assets/wpbakery.1a30df85.svg";